module.exports = __webpack_public_path__ + "img/icon2_2.58bc4d7d.png";